import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Job } from '@etnrlz-jobs/shared';
import { api } from '../lib/api';
import { ErrorBox, fmtDate, JobStatusBadge, PageHeader, Spinner } from '../components/ui';

export function JobsListPage() {
  const [jobs, setJobs] = useState<Job[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api<{ jobs: Job[] }>('/admin/jobs')
      .then((r) => setJobs(r.jobs))
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <div>
      <PageHeader
        title="Vagas"
        subtitle="Crie vagas com IA e acompanhe candidaturas"
        actions={
          <Link to="/vagas/nova" className="btn-primary">
            + Nova vaga
          </Link>
        }
      />
      {error && <ErrorBox message={error} />}
      {!jobs && !error && (
        <div className="flex justify-center py-16 text-slate-400">
          <Spinner className="h-6 w-6" />
        </div>
      )}
      {jobs && jobs.length === 0 && (
        <div className="card py-12 text-center text-slate-400">
          <p className="mb-4">Nenhuma vaga ainda.</p>
          <Link to="/vagas/nova" className="btn-primary">
            Criar a primeira vaga com IA
          </Link>
        </div>
      )}
      <div className="space-y-3">
        {jobs?.map((job) => (
          <Link key={job.id} to={`/vagas/${job.id}`} className="card block hover:border-ink-500">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-3">
                  <h2 className="font-semibold text-slate-100">{job.title}</h2>
                  <JobStatusBadge status={job.status} />
                </div>
                <p className="mt-1 text-xs text-slate-400">
                  Criada em {fmtDate(job.createdAt)} · {job.applicationCount}{' '}
                  {job.applicationCount === 1 ? 'candidatura' : 'candidaturas'}
                </p>
              </div>
              <span className="text-slate-500">→</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
